import { Radio, FormControlLabel, FormLabel } from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import React, { useState } from 'react';
import { Box, Grid, TextField,  MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import '../Rampwalk/Rampwalk.css';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import FluidComponent from '../Reusable/FluidComponent';
import { generateVideo } from '../../services/apiService';
import './Reels.css';
import { showToast } from '../Toast/CommonToast';
import { useReelsWebSocket } from '../../context/ReelWebSocketProvider';
import { useCreditPoints } from '../../services/CreditPointsProvider';
import CommonPopup from '../Popup/Popup';
import ErrorPopup from '../Popup/ErrorPopup/ErrorPopup';

export default function UploadReels({
    setQuotes, quotes, setDuration, duration,
    allSearchImages, setAllSearchImages,
    image, setImage, setSelectedImageId, selectedImageId,
    eventIdRes, setIsLoading, handleFetchJson,
    handleSearchVideoId,
    headerHeight = 0
}: any) {
    const [isAudioSound, setIsAudioSound] = useState<boolean>(true);
    const [viewType, setViewType] = React.useState<'grid' | 'masonry'>('masonry');
const creditsPoints = (eventIdRes && eventIdRes.find((item: any) => item.eventName === "Reels")?.videoCreditsForduration) || {};
const totalPoints = ((creditsPoints?.[`${duration}s`] || 0) + (isAudioSound ? 50 : 0) + 25); // 25 points for images
    const { reconnectWebSocket } = useReelsWebSocket();
    const userId = localStorage.getItem("userId") || ""
    const eventId = eventIdRes && eventIdRes.find((item:any)=>item.eventName === "Reels")?._id || "";
    const { fetchCreditPoints } = useCreditPoints();
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedPopupItem, setSelectedPopupItem] = useState<any>(null);
  const [errorPopupOpen, setErrorPopupOpen] = useState({ open: false, message: "" });
  

    const handleReelsGenerate = async()=>{
        if(!quotes || quotes.trim() === ''){
            showToast("Please enter topics", 'error');
            return;
        }
        reconnectWebSocket();
            setIsLoading(true);
        try{
            const payLoad = {
                userId: userId,
                text: quotes,
                duration: duration,
                needAudio: isAudioSound,
                eventId: eventId,
            }
            const response = await generateVideo(payLoad);
                setIsLoading(false);
                fetchCreditPoints(userId)
            if(response.status === "success"){
                setIsLoading(false);
                showToast(response?.message,  'success')
                setAllSearchImages([response?.data, ...allSearchImages]);
                setSelectedImageId(response?.data?._id || null);
                setImage(response?.data?.url || response?.data?.inputData?.imageUrl || '');
                setQuotes('');
            }else{
                console.log("Error in reels generation", response)
                setIsLoading(false);
                showToast(response?.message, 'error')
            }
        }catch(error:any){
            console.log("Insufficient credits", error)
            if(error?.message === 'Insufficient credits' || error?.message === "Credits Not Found"){
                setErrorPopupOpen({ open: true, message: error?.message || "An error occurred" });
                setIsLoading(false);
                return;
            }
            showToast(error?.message, 'error')
        }
    }


    // Calculate available height for FluidComponent based on parent header
    const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);
    React.useEffect(() => {
        const handleResize = () => setWindowHeight(window.innerHeight);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const fluidHeight = Math.max(windowHeight - headerHeight - 170, 300); // 70 for UploadReels controls

    return (
        <Grid item xs={12} className="upload-mainContainerReels" style={{height:'calc(100dvh - 150px)', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <Box className="upload-container">
                {errorPopupOpen && (
   <ErrorPopup
                    open={errorPopupOpen.open}
                    message={errorPopupOpen.message}
                    onClose={() => setErrorPopupOpen({ open: false, message: "" })}
                />
)}
                 
                    <Box className="width100 upload-text-field">
                        {/* <Typography variant="h6" gutterBottom className='uploadTexts'>
                            Topic
                        </Typography> */}
                        <TextField
                            fullWidth
                            placeholder="Ex: Believe Yourself, Birthday, Festival, etc..."
                            multiline
                            rows={3}
                            className="textField"
                            label="Topics"
                            value={quotes}
                            onChange={(e) => setQuotes(e.target.value)}
                        />
                    </Box>
                
            </Box>
            <Box className="upload-container" mb={2} mt={2}>
                <Box className="formControl width50" sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <FormControl size='medium' variant="outlined" className='textField duration' sx={{ minWidth: { md: 120, lg: 180 }, maxWidth: 180 }}>
                        <InputLabel id="duration-label">Select Duration</InputLabel>
                        <Select
                            labelId="duration-label"
                            id="duration-select"
                            label="Select Duration"
                            defaultValue={"6"}
                            value={duration}
                            onChange={(e) => setDuration(e.target.value as number)}
                        >
                            <MenuItem value={"6"}>5 sec</MenuItem>
                            <MenuItem value={"10"}>10 sec</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl component="fieldset" className='textField' sx={{ minWidth: { md: 120, lg:180 }, maxWidth: 180 }}>
                        <FormLabel id="radio-group-label">Background music:</FormLabel>
                        <RadioGroup
                            row
                            aria-label="audio-boolean"
                            name="audio-boolean-group"
                            value={isAudioSound ? 'true' : 'false'}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIsAudioSound(e.target.value === 'true')}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="Yes" />
                            <FormControlLabel value="false" control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <Box className="width50 reelsButton">
                    
                    <ReusableButton
                    onClick={handleReelsGenerate}
                    disabled={!quotes}
                    >
                        {`Genrerate (${totalPoints} Credits)`}
                    </ReusableButton>
                </Box>
            </Box>
            <Box className="rampwalk-uploaded-images" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', height: '100%', paddingBottom: 0 }}>
                {Array.isArray(allSearchImages) && allSearchImages.length > 0 && (
                    <Box style={{ flex: 1, minHeight: 0, maxHeight: fluidHeight, display: 'flex', flexDirection: 'column' }}>
                        <FluidComponent
                            items={allSearchImages.map((item: any) => ({
                                ...item,
                                thumbnailUrl: item?.thumbnailUrl || item?.inputData?.imageUrl || '',
                            }))}
                            selectedIndex={allSearchImages.findIndex((img: any) => img._id === selectedImageId)}
                            onSelect={(idx: number) => {
                                const selected = allSearchImages[idx];
                                setSelectedPopupItem(selected);
                                setSelectedImageId?.(selected?._id || null);
                                setImage?.(selected?.url || selected?.inputData?.imageUrl || '');
                                handleFetchJson?.(selected._id);
                                handleSearchVideoId?.(selected._id);  
                            }}
                            isLoading={false}
                            setPopupOpen={setPopupOpen}
                            headingText="Generated Reels"
                            chips={allSearchImages?.map((item: any) => item.isGenerated).length}
                            viewType={viewType}
                            setViewType={setViewType}
                            maxHeight={fluidHeight - 250}
                        />
                    </Box>
                )}
                {popupOpen && (
                    <CommonPopup 
                        open={popupOpen}
                        onClose={() => { setPopupOpen(false); setSelectedPopupItem(null); }}
                        leftColumnType='prompt'
                        rightColumnType='image'
                        leftPromptText={selectedPopupItem?.userContent || ''}
                        previewImageSrc={selectedPopupItem?.inputData?.imageUrl || ''}
                        audioUrl={selectedPopupItem?.audioUrl || ''}
                    />
                )}
            </Box>
        </Grid>
    );
}